











import Vue from 'vue'

import selectSearchable from '@/components/controls/select/select-searchable/select-searchable.vue'
import { DefaultListModel } from '@/components/controls/select/select-searchable/types'
import { OkatoModel} from '@/types/common'

export default Vue.extend({
    name: 'okato-selector',
    components: {
        selectSearchable
    },
    props: {
        item: Object as () => OkatoModel
    },
    mounted() {
        this.$root.$on('clearOkatoList', () => {
            this.currentValue.Value = '';
            this.currentValue.Name = '';
            this.keyword = '';
        });
        this.currentValue.Name = this.item.FullName;
        this.currentValue.Value = this.item.Code;
        this.currentValue.Code = this.item.Okato
        this.list = this.$store.getters.okatoList as OkatoModel[];
    },
    data() {
        return {
            list: [] as OkatoModel[],
            keyword: '',
            currentValue: {
                Name: '',
                Value: '',
                Code: '',
                Selected: false
            } as DefaultListModel
        }
    },
    methods: {
        async search(keyword: string) {
            this.keyword = keyword;
            if (!keyword || keyword.length < 1) {
                this.list = this.$store.getters.okatoList;
                return;
            }
            this.list = this.$store.getters.okatoList.filter((s: OkatoModel) => s.FullName.toLowerCase().includes(keyword.toLowerCase()));
        },
        select(data: DefaultListModel) {
            if (!data.Name) return;
            this.currentValue = data;
            const currentItem = this.list.find(item => item.Code === data.Value)
            if(currentItem && currentItem.FullName) {
                this.currentValue.Name = currentItem.FullName;
            }
            this.$emit('select', currentItem)
        },
    },
    computed: {
        okatoList(): DefaultListModel[] {
            const list = this.list.map((item) => {
                return {
                    Value: item.Code ? item.Code : '',
                    Name: item.FullName ? item.FullName : '',
                    Code: item.Okato,
                    Selected: false
                }
            })
            return list;
        },
        placeholder(): string {
            return this.currentValue.Name ? '' : 'Выберите код из списка или введите свой';
        }
    },
    watch: {
        'item.Name'() {
            this.keyword = '';
            if (this.currentValue.Name) return;
            if (this.item.Code) this.currentValue.Value = this.item.Code;
            if (this.item.FullName) this.currentValue.Name = this.item.FullName;
        },
        async item() {
            if (this.currentValue.Selected) return;
            await this.search(this.item.FullName);
            if (this.item.Code) {
                this.currentValue.Value = this.item.Code
                if (this.currentValue.Name)
                    this.currentValue.Name = this.item.FullName;
            }
            else if (this.list.length > 0) {
                let filteredList = this.list.filter((listItem) => listItem.FullName?.toLowerCase() === this.item.FullName.toLowerCase());

                if (filteredList.length !== 1) {
                    filteredList = this.list.filter((listItem) => listItem.FullName?.toLowerCase() === this.item.FullName.toLowerCase());
                }

                if (filteredList.length === 1) {
                    this.currentValue.Code = filteredList[0].Code || '';
                    this.item.Okato = this.currentValue.Code.toString();
                    this.item.Code = this.currentValue.Value.toString();
                    this.item.FullName = this.currentValue.Name.toString();
                    this.$emit('select', this.item);
                }
            }
        }
    }
})
